import PropTypes from 'prop-types';
import { Link } from 'react-router';

import css from 'styles/components/cart/cartHeadBanner.scss';

const makePromo = ({
  cta,
  heading,
  src,
  body,
  ctalink
} = {}, testId) => {

  if (body) {
    return (
      <div style={{ backgroundImage: `url('${src}')` }}>
        <h4>{heading}</h4>
        <p>{body}</p>
        <Link to={ctalink} data-test-id={testId('promoLearnMore')}>{cta}</Link>
      </div>
    );
  }
};

const CartHeadBanner = ({ promoData }, { marketplace, testId }) => {
  const { cart: { showTopBanner, returnWindow } } = marketplace;

  if (!showTopBanner) {
    return null;
  }

  return (
    <div className={css.container} data-test-id={testId('CartHeadBanner')}>
      <div className={css.freeShip}>
        <h4>Free Shipping and Returns</h4>
        <p>{returnWindow} days to return items for a refund!</p>
        <Link to="/c/general-questions#shipping-and-return" data-test-id={testId('shippingLink')}>Shipping and Return Policy</Link>
      </div>
      <div className={css.privacy}>
        <h4>Privacy Policy</h4>
        <p>We don’t rent or sell your personal information to anyone.</p>
        <Link to="/c/privacy-policy" data-test-id={testId('privacyLink')}>Read our Privacy Policy</Link>
      </div>
      { promoData && makePromo(promoData, testId) /* if promo data comes back (in symphony) */ }
    </div>
  );
};

CartHeadBanner.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

export default CartHeadBanner;
